import { Core as YubinBangoCore } from "yubinbango-core2";

const dataMixin =  {
    postCode1: '',
    postCode2: '',
    perfectureSelected: '',
    city: '',
    address1: ''
}
export const CustomYuBinBango = {
    data() {
        return Object.assign({}, dataMixin)
    },
    methods: {
        autoFillAddress(postCode1, postCode2) {
            if (postCode1 && postCode2) {
                if (this.$refs.postCode1.getAttribute('data-value')) {
                    this.$refs.postCode1.setAttribute('data-value', '');
                    return
                } 
                if (this.$refs.postCode2.getAttribute('data-value')) {
                    this.$refs.postCode2.setAttribute('data-value', '')
                    return
                }
                const zipCode = postCode1 + postCode2;
                if (!isNaN(zipCode)) {
                    new YubinBangoCore(zipCode, (value) => {
                        this.perfectureSelected = value.region;
                        this.city = value.locality;
                        this.address1 = value.street;
                    });
                    if (this.class_select) {
                        this.class_select = ''
                    }
                }
            }
           
        }
    },
    watch: {
        postCode1: {
            handler() {
                this.autoFillAddress(this.postCode1, this.postCode2)
            }
        },
        postCode2: {
            handler() {
                this.autoFillAddress(this.postCode1, this.postCode2)
            }
        },
    },
    mounted() {
        for (const key in dataMixin) {
            this[key] = this.$refs[key].getAttribute('data-value')
        }
        if (this.class_select && this.perfectureSelected) {
            this.class_select = ''
        }
    },
}
